import { ROUTE_PATH } from '../../../utils/constants'
import { IHeaderMenuItem } from './HeaderMenu.types'

export const headerMenuItems: IHeaderMenuItem[] = [
  {
    link: ROUTE_PATH.aboutUs,
    subitems: [ROUTE_PATH.aboutUs, ROUTE_PATH.team, ROUTE_PATH.leadership, ROUTE_PATH.teamContactUs],
  },
  {
    link: ROUTE_PATH.whatWeDo,
    subitems: [ROUTE_PATH.technologies, ROUTE_PATH.industries],
  },
  { link: ROUTE_PATH.vacancies },
  { link: ROUTE_PATH.events },
  { link: ROUTE_PATH.news },
  { link: ROUTE_PATH.connectWithUs, highlighted: true },
]
